export const MFA_METHOD_CATEGORIES = {
  email: 'Email',
  authenticator: 'Popular Authenticators',
  enterprise: 'Enterprise & Workforce',
  password_manager: 'Password Managers',
  open_source: 'Open Source & Privacy',
  security_key: 'Hardware & Security Keys'
};

export const CATEGORY_ORDER = [
  'email',
  'authenticator',
  'enterprise',
  'password_manager',
  'open_source',
  'security_key'
];

export const COMMON_AUTHENTICATOR_APPS = [
  'Microsoft Authenticator',
  'Google Authenticator',
  'Twilio Authy',
  'Duo Mobile',
  '1Password',
  'Bitwarden Authenticator',
  'Okta Verify',
  'Other TOTP app'
];

export const getMethodLabel = (key, catalog = []) => {
  if (!key) return 'MFA method';
  return catalog.find((method) => method.key === key)?.label
    || String(key).replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

export const groupMethodsByCategory = (catalog = [], categoryOrder = CATEGORY_ORDER) => {
  const grouped = {};
  categoryOrder.forEach((category) => {
    grouped[category] = [];
  });

  catalog.forEach((method) => {
    const category = method.category || (method.type === 'email' ? 'email' : 'authenticator');
    if (!grouped[category]) {
      grouped[category] = [];
    }
    grouped[category].push(method);
  });

  return categoryOrder
    .filter((category) => grouped[category]?.length > 0)
    .map((category) => ({
      key: category,
      label: MFA_METHOD_CATEGORIES[category] || category,
      methods: grouped[category]
    }));
};

export const TOTP_METHOD_KEYS = [];
